import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import Tabs from '../../components/Tabs';
import { ActiveTab } from '../../hoc/ActiveTab';
import { setPageData } from '../../redux/reducers/pageSlice';
import { TabsNames } from '../../utils/@globalTypes';
import BookingModuleSettings from './BookingModuleSettings';
import IntegrationPlaceholder from './IntegrationPlaceholder';
import styles from './Integrations.module.scss';

const tabsList = [
  {
    title: 'Модуль бронирования',
    path: TabsNames.INTEGRATION_BOOKING_MODULE,
  },
  { title: 'iCalendar', path: TabsNames.INTEGRATION_ICAL },
  {
    title: 'Менеджер каналов',
    path: TabsNames.INTEGRATION_CHANNEL_MANAGER,
  },
];

const Integrations = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState<TabsNames>();

  useEffect(() => {
    dispatch(
      setPageData({
        pageTitle: 'Интеграции',
        pageDescription: 'Подключения модулей и календарей',
      }),
    );
    return () => {
      dispatch(setPageData(null));
    };
  }, [dispatch]);

  return (
    <section className={styles.container}>
      <Tabs tabsList={tabsList} activeTab={activeTab}>
        <Routes>
          <Route
            index
            element={
              <Navigate to={TabsNames.INTEGRATION_BOOKING_MODULE} replace />
            }
          />
          <Route
            path={TabsNames.INTEGRATION_BOOKING_MODULE}
            element={
              <ActiveTab
                setActiveTab={setActiveTab}
                path={TabsNames.INTEGRATION_BOOKING_MODULE}
              >
                <BookingModuleSettings />
              </ActiveTab>
            }
          />
          <Route
            path={TabsNames.INTEGRATION_ICAL}
            element={
              <ActiveTab
                setActiveTab={setActiveTab}
                path={TabsNames.INTEGRATION_ICAL}
              >
                <IntegrationPlaceholder
                  title="iCalendar"
                  description="Подключение и синхронизация календарей появятся позже"
                />
              </ActiveTab>
            }
          />
          <Route
            path={`${TabsNames.INTEGRATION_ICAL}/:rentalObjectId`}
            element={
              <ActiveTab
                setActiveTab={setActiveTab}
                path={TabsNames.INTEGRATION_ICAL}
              >
                <IntegrationPlaceholder
                  title="iCalendar"
                  description="Подключение и синхронизация календарей появятся позже"
                />
              </ActiveTab>
            }
          />
          <Route
            path={TabsNames.INTEGRATION_CHANNEL_MANAGER}
            element={
              <ActiveTab
                setActiveTab={setActiveTab}
                path={TabsNames.INTEGRATION_CHANNEL_MANAGER}
              >
                <IntegrationPlaceholder
                  title="Менеджер каналов"
                  description="Подключения и обмен бронированиями через менеджер каналов появятся позже."
                />
              </ActiveTab>
            }
          />
        </Routes>
      </Tabs>
    </section>
  );
};

export default Integrations;
